import React, { FunctionComponent, useState } from 'react';
import { Button } from '@havenengineering/module-shared-owners-ui/dist/components/Button';
import clsx from 'clsx';

import { accordionClick } from '../../helpers/googleTag';
import { DrainDownOption } from './DrainDown.enum';
import styles from './Option.module.scss';

type Props = {
  option: DrainDownOptionData;
  onChoose: (option: DrainDownOption) => void;
};

const Option: FunctionComponent<Props> = ({ option, onChoose }) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    accordionClick(`${option.title} drain down details`, !expanded);
    setExpanded(!expanded);
  };

  const getIcon = () => {
    switch (option.type) {
      case DrainDownOption.basic:
        return '/assets/drain-down/basic.svg';
      case DrainDownOption.heating:
        return '/assets/drain-down/heating.svg';
      case DrainDownOption.lodge:
        return '/assets/drain-down/twin.svg';
      default:
        return null;
    }
  };

  const getTitleComponent = () => {
    if (option.title) {
      return (
        <p className={styles.title}>
          <strong style={{ fontWeight: 500 }}>{option.title}</strong> Drain Down
          and reconnection
          <strong style={{ fontWeight: 500 }}> £{option.price}</strong>
        </p>
      );
    } else {
      return (
        <p className={styles.title}>
          I’m organising my own{' '}
          {option.type === DrainDownOption.diyCaravan ? '(Caravan)' : '(Lodge)'}
        </p>
      );
    }
  };

  const icon = getIcon();
  const title = getTitleComponent();

  return (
    <div className={styles.root} data-testid={option.type}>
      <div className={styles.content}>
        {icon && (
          <div className={styles.imageContainer}>
            <img src={icon} />
          </div>
        )}
        {title}
      </div>
      <div className={styles.actions}>
        <Button
          className={styles.button}
          onClick={() => onChoose(option.type)}
          variant="contained"
          fullWidth
        >
          Choose
        </Button>
        {(option.includes || option.notes) && (
          <Button
            className={styles.detailsButton}
            onClick={handleExpandClick}
            variant="outlined"
          >
            Details
            <img
              className={clsx(styles.expand, {
                [styles.expandOpen]: expanded,
              })}
              src="https://www.haven.com/assets/icons/arrow-ios-up-blue.svg"
              alt="arrow"
            />
          </Button>
        )}
      </div>
      {expanded && (
        <div className={styles.details}>
          <ul className="owners-body">
            {option.includes?.map((include, index) => (
              <li key={index}>{include}</li>
            ))}
          </ul>
          <ul className="owners-body">
            {option.notes?.map((note, index) => (
              <li key={index}>{note}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Option;
